import { FC, useState, useEffect, PropsWithChildren } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { constants } from 'app/utils';
import { userManager } from 'app/services';

export const ProtectedRoute: FC<PropsWithChildren<{ path: string }>> = ({ children, path }) => {
  const [isUserLoggedIn, setUserLoggedIn] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const getUserLoginStatus = async () => {
      const userData = await userManager.getUserData();
      setUserLoggedIn(!!userData);
    };

    getUserLoginStatus();
  }, []);

  if (isUserLoggedIn === undefined) {
    return <></>;
  } else if (isUserLoggedIn) {
    return (
      <Route exact path={path}>
        {children}
      </Route>
    );
  } else {
    return <Redirect exact from={path} to={constants.Routes.Home} />;
  }
};
